import {OrderEventType} from "./OrderEventType";
import {OrderViewModel} from "../OrderViewModel";

export class OrderEvent {

    public order: OrderViewModel;

    private constructor(order: OrderViewModel, public type: OrderEventType) {
        this.order = order;
    }

    public static created(order: OrderViewModel): OrderEvent {
        return new OrderEvent(order, OrderEventType.CREATED);
    }

    public static updated(order: OrderViewModel): OrderEvent {
        return new OrderEvent(order, OrderEventType.UPDATED);
    }

    public static completed(order: OrderViewModel): OrderEvent {
        return new OrderEvent(order, OrderEventType.COMPLETED);
    }

    public static closed(order: OrderViewModel): OrderEvent {
        return new OrderEvent(order, OrderEventType.CLOSED);
    }
}
